import { observe } from 'mobx';

observe($.stores.fastEntry, 'unit', () => {
  if ($.stores.fastEntry.isReel) {
    $('[data-fastentry-form]').attr('data-unit', '');
  } else {
    $('[data-fastentry-form]').attr('data-unit', $.stores.fastEntry.unit ? $.stores.fastEntry.unit.label : '');
  }
});

observe($.stores.fastEntry, 'selectUrl', () => {
  if ($.stores.fastEntry.isReel) {
    $('[data-fastentry-quantity]').hide();
    $('[data-fastentry-form]').attr('data-unit', '');
  } else {
    $('[data-fastentry-quantity]').show();
  }

  $('[data-fastentry-form]').attr(
    'data-reels',
    $.stores.fastEntry.isReel && $.stores.fastEntry.selectUrl ? $.stores.fastEntry.selectUrl : '',
  );
  $('[data-fastentry-form]').attr(
    'data-contracts',
    $.stores.fastEntry.hasContracts && $.stores.fastEntry.selectUrl ? $.stores.fastEntry.selectUrl : '',
  );
});
